import React from 'react';
import { AlertTriangle, Trash2, Ban } from 'lucide-react';
import { Modal } from './Modal';
import { Button } from './Button';

export interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  variant?: 'danger' | 'warning';
  loading?: boolean;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Onayla',
  variant = 'danger',
  loading = false,
}) => {
  const isDanger = variant === 'danger';

  const icon = isDanger
    ? <Trash2 size={20} className="text-red-600" />
    : <Ban size={20} className="text-amber-600" />;

  const headerBg = isDanger ? 'bg-red-50' : 'bg-amber-50';
  const titleColor = isDanger ? 'text-red-800' : 'text-amber-800';
  const messageBg = isDanger ? 'bg-red-50 border-red-200 text-red-700' : 'bg-amber-50 border-amber-200 text-amber-700';
  const confirmClass = isDanger
    ? 'bg-red-600 hover:bg-red-700'
    : 'bg-amber-600 hover:bg-amber-700';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
      title={
        <div className={`flex items-center gap-2 -m-5 px-5 py-4 w-full rounded-t-2xl ${headerBg}`}>
          {icon}
          <span className={`font-bold ${titleColor}`}>{title}</span>
        </div>
      }
      showCloseButton={false}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            Vazgeç
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            loading={loading}
            className={confirmClass}
          >
            {confirmText}
          </Button>
        </>
      }
    >
      <div className={`p-3 rounded-lg border text-sm ${messageBg}`}>
        <div className="flex items-start gap-2">
          <AlertTriangle size={16} className="mt-0.5 shrink-0" />
          {/* Satır sonları korunur: çift indirim uyarısı ürünleri ayrı satırlarda sayar. */}
          <p className="whitespace-pre-line">{message}</p>
        </div>
      </div>
    </Modal>
  );
};
